<div class="tooltip " style="display: inline-block !important;" (click)="callAnotherComponent()">
    <ng-content></ng-content> <!-- Content from parent component -->
    <span class="tooltiptext ">{{ tooltipText }}</span> <!-- Tooltip text -->
  </div>
  